import { render, staticRenderFns } from "./ToggleAllowWarranty.vue?vue&type=template&id=6869e24e&scoped=true"
import script from "./ToggleAllowWarranty.vue?vue&type=script&lang=ts"
export * from "./ToggleAllowWarranty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6869e24e",
  null
  
)

export default component.exports